import useFlags from "./useFlags";

export { useFlags };
